import { takeLatest } from 'redux-saga/effects';
import { QRVALUE_ACTION_TYPES, VEHICLE_CAPABLE_ACTION, SUBSCRIPTION_ACTION, REMOTE_STATUS_ACTION,
  FORGEROCK_ACTION_TYPES } from '../actionTypes';
import { getQrAuthValue } from './QrAuthSagas';
import { getVehicleCapable } from './VehicleCapableSagas';
import { getSubscription } from './SubscriptionSagas';
import { getForgerockAuthValue } from './ForgeRockSagas';
import { getUpdatedRemoteStatus } from './UpdateRemoteSubscriptionSagas';

export function* root() {
  yield takeLatest(VEHICLE_CAPABLE_ACTION.IS_VEHICLE_CAPABLE, getVehicleCapable);
  yield takeLatest(SUBSCRIPTION_ACTION.IS_SUBSCRIPTION, getSubscription);
  yield takeLatest(QRVALUE_ACTION_TYPES.POST.IN_PROGRESS, getQrAuthValue);
  yield takeLatest(FORGEROCK_ACTION_TYPES.IS_AUTHORIZED, getForgerockAuthValue);
  yield takeLatest(REMOTE_STATUS_ACTION.IS_REMOTE_SUBSCRIPTION, getUpdatedRemoteStatus);
}
